import { StateCreator } from "zustand";

import {
  ContinuityActions,
  ContinuitySlice,
  RollForwardWizardStore
} from "../roll_forward_wizard_store_types";

export const createContinuitySlice: StateCreator<
  RollForwardWizardStore,
  [["zustand/immer", never]],
  [],
  ContinuitySlice
> = () => ({
  continuity: {}
});

export const createContinuityActions = (): ContinuityActions => ({});
